<div class="page-wrapper">
  <app-wf-navbar></app-wf-navbar>
  <div class="main-wrapper">
    <app-wf-hero></app-wf-hero>
    <app-wf-main-content></app-wf-main-content>
  </div>
  <app-wf-cta-banner></app-wf-cta-banner>
  <app-wf-footer></app-wf-footer>
</div>
